import React from "react";
import { render } from "react-dom";
import { Link, Router, Navigation } from "react-router";
import AppHeader from "js/components/elements/sdk-header";
import AppFooter from "js/components/elements/sdk-footer";
import routes from "js/sdk-routes";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({

  mixins: [Navigation],

  getInitialState: function() {
    return {
      currentApplication: {}
    };
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  componentWillMount: function() {
    if((window.location.hash).indexOf("enroll")> -1) {
      return;
    }
    if((window.location.hash).indexOf("zoom-identity-check")> -1) {
      if (FN_MODE !== "qa") {
        window.location.replace("https://dev.facetec.com/zoom-identity-check/");
        return
      }
      else {
        window.location.replace("https://qadev.zoomlogin.com/zoom-identity-check/");
        return;
      }
    }
    // LOGGLY: reimplement without promises and with less nested calling of functions
    UserHandler.checkTokenValidOrLogout().then((response) => {}).catch( (error) => {
      return this.context.router.push("/signin");
    });
  },

  render: function() {
    //Include header and footer by default, or set static value of includeHeaderFooter=false on any component to hide it
    let includeHeaderFooter = _.isUndefined(this.props.children.props.route.component.includeHeaderFooter) ? true : this.props.children.props.route.component.includeHeaderFooter;
    return (
        <div className="app">
          { includeHeaderFooter ? <AppHeader application={this.state.currentApplication}></AppHeader> : null }
          <div id="app-wrapper" className={ includeHeaderFooter ? "" : null } style={{height:"100%", width:"100%"}}>
            {this.props.children}
            { includeHeaderFooter ? <AppFooter/> : null }
          </div>
        </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/app.jsx